(() => {
    "use strict";
const observer = new MutationObserver(() => {
    const rechargeWidget = document.querySelector("recharge-subscription-widget");
    
    if (rechargeWidget && rechargeWidget.shadowRoot) {
        // Target rc-learn-more
        const rcLearnMore = rechargeWidget.shadowRoot.querySelector("rc-learn-more");
        if (rcLearnMore && rcLearnMore.shadowRoot) {
            const learnMoreButton = rcLearnMore.shadowRoot.querySelector(".rc-learn-more__trigger");
            if (learnMoreButton) {
                learnMoreButton.style.fontFamily = "Montserrat, sans-serif";
                console.log("Font applied to .rc-learn-more__trigger");
            }
        }

        // Target rc-benefits
        const rcBenefits = rechargeWidget.shadowRoot.querySelector("rc-benefits");
        if (rcBenefits && rcBenefits.shadowRoot) {
            const benefitsList = rcBenefits.shadowRoot.querySelector(".rc-benefits__list");
            if (benefitsList) {
                const listItems = benefitsList.querySelectorAll("li");
                listItems.forEach(li => {
                    li.style.fontSize = "14px";
                });
                console.log("Font size applied to all li elements in .rc-benefits__list");
            }
        }
    }
});

// Observe DOM mutations
observer.observe(document.body, { childList: true, subtree: true });



document.addEventListener('DOMContentLoaded', function() {
  function updatePrice(option) {
    const swatchElements = document.querySelectorAll('.swatch-element');
    swatchElements.forEach(swatch => {
      const basePriceCents = parseFloat(swatch.querySelector('.swatch-element__per-weight').getAttribute('data-base-price'));
      const totalOz = parseInt(swatch.querySelector('.swatch-element__per-weight').getAttribute('data-total-oz'));
      const unitType = swatch.querySelector('.swatch-element__per-weight').getAttribute('data-type');
      const basePrice = (basePriceCents / 100).toFixed(2);
      const pricePerUnit = (basePrice / totalOz).toFixed(2);
      let finalPrice = pricePerUnit;
      if (option === 'subscription') {
        finalPrice = (pricePerUnit * 0.9).toFixed(2);  // Apply 10% discount
      }
      const priceLabel = swatch.querySelector('.swatch-element__per-weight');
      priceLabel.textContent = `($${finalPrice} / ${unitType})`;
    });
  }
  function observeShadowRoot() {
    const shadowHost = document.querySelector('recharge-subscription-widget');  // Change to your shadow host selector
    if (shadowHost) {
      const shadowRoot = shadowHost.shadowRoot;

      const observer = new MutationObserver(() => {
        const selectedOption = shadowRoot.querySelector('input[name="purchaseOption"]:checked');
        if (selectedOption) {
          if (selectedOption.value === 'subscription') {
            updatePrice('subscription');
          } else {
            updatePrice('onetime');
          }
        }
      });
      observer.observe(shadowRoot, { childList: true, subtree: true });
      const initialSelectedOption = shadowRoot.querySelector('input[name="purchaseOption"]:checked');
      if (initialSelectedOption) {
        if (initialSelectedOption.value === 'subscription') {
          updatePrice('subscription');
        } else {
          updatePrice('onetime');
        }
      }
    }
  }
  observeShadowRoot();
});


    const e = (e, t = {}, i = {}, n = !0) => {
            Object.keys(t).forEach((i => {
                const a = t[i],
                    o = n ? `[${a}]` : a;
                e[i] = document.querySelector(o) || !1
            })), Object.keys(i).forEach((t => {
                const a = i[t],
                    o = n ? `[${a}]` : a;
                e[t] = [...document.querySelectorAll(o)]
            }))
        },
        t = {},
        i = {
            gallery: "data-product-gallery",
            thumbWrapper: "data-thumbnail-wrapper",
            subPrice: "data-price-subsave",
            oneTimePrice: "data-price-onetime",
            subSaveRadio: "data-radio-subsave"
        },
        n = {
            thumbs: "data-desktop-thumbnail",
            variants: "data-variant-media-id",
            weighInputs: "data-weight-input-kill"
        },
        a = e => {
            r(e), t.thumbs.forEach((t => {
                t == e ? t.classList.add("active") : t.classList.remove("active")
            }))
        },
        o = e => {
            const i = t.thumbWrapper.getBoundingClientRect();
            t.thumbWrapper.scrollTo({
                top: e.offsetTop - i.height / 2,
                behavior: "smooth"
            })
        },
        r = e => {
            const a = e.getAttribute("data-media-id"),
                o = t.variants.find((e => e.getAttribute(n.variants) === a));
            if (o) {
                const e = o.getAttribute("data-variant-id"),
                    n = (e => {
                        const {
                            product: t
                        } = window.fdc;
                        return t.variants.find((t => t.id === e))
                    })(parseInt(e));
                window.currentVariant = n;
                const a = new Event("variantChange");
                document.dispatchEvent(a), (e => {
                    const n = (e.price / 100).toFixed(2),
                        a = (e.price / 100 * .90).toFixed(2),
                        o = document.querySelector("[data-price-mutation-watcher]") || !1;
                    if (o && o.removeAttribute("data-price-mutation-watcher"), t.oneTimePrice || (t.oneTimePrice = document.querySelector(`[${i.oneTimePrice}]`)), t.subPrice || (t.subPrice = document.querySelector(`[${i.subPrice}]`)), t.oneTimePrice) {
                        const e = document.querySelector(`[${i.subSaveRadio}]`);
                        t.mainPrice.innerHTML = `$${e.checked?a:n}`, t.oneTimePrice.innerHTML = `$${n}`, t.subPrice.innerHTML = `$${a}`
                    } else t.mainPrice.innerHTML = `$${n}`
                })(n), ((e, i) => {
                    if (!t.variantIDSelector) return;
                    const n = window.fdc.product.options.find((e => "Weight" === e.name || "Size" === e.name && 2 == e.values.length));
                    if (!n) return;
                    const a = e.options.find((e => n.values.includes(e))),
                        o = document.querySelector(`#${i.getAttribute("for")}`) || !1;
                    o && (o.checked = !0), t.variantIDSelector.value = e.id, t.weightSelector.element.value = a
                })(n, o)
            }
        };
    document.addEventListener("rc-widget-loaded", (() => {
        (document.querySelectorAll(".rc-option__subsave, .rc-option__onetime") || []).forEach((e => e.addEventListener("click", (() => {
            const e = document.querySelector("[data-weight-input-kill]:checked"),
                t = document.querySelector("[data-weight-input-kill]:not(:checked)"),
                i = document.querySelector(`label[for="${e.getAttribute("id")}"]`);
            document.querySelector(`label[for="${t.getAttribute("id")}"]`).click(), i.click()
        }))))
    })), document.addEventListener("optionSelectInit", (({
        detail: e
    }) => {
        t.variantIDSelector = e.optionSelector.variantIdField, t.weightSelector = e.optionSelector.selectors.find((e => "Weight" === e.name || "Size" === e.name))
    }));
    const c = {},
        d = {
            subDD: 'name="selling_plan"',
            subRow: "data-subscription-options-box",
            oneTime: "data-option-onetime",
            subSave: "data-option-subsave",
            subSaveRadio: "data-radio-subsave"
        },
        s = {
            planButtons: "data-plan-frequency",
            weights: "data-total-oz"
        },
        u = () => {
            const e = document.querySelector("[data-option-subsave] .rc_widget__option__label") || !1;
            if (e) {
                const t = e.querySelector(".rc-option__price"),
                    i = document.createElement("span");
                i.innerHTML = "<br/>+ Free Shipping", e.insertBefore(i, t), document.dispatchEvent(new Event("rc-widget-loaded"))
            } else setTimeout((() => u()), 500)
        },
   l = e => {
            c.weights.forEach((t => {
                const i = t.getAttribute("data-base-price"),
                    type = t.getAttribute("data-type"),
                    n = t.getAttribute(s.weights),
                    a = "subscription" === e ? .90 : 1;
              
                const unit = type;
    t.innerHTML = `($${(i * a / 100 / n).toFixed(2)} / ${unit})`;
              
            }))
        },
        p = () => {
            c.subSaveRadio || (c.subSaveRadio = document.querySelector(`[${d.subSaveRadio}]`)), window.fdc.product || (window.fdc.product = window.wholeSaleProduct);
            const {
                product: e
            } = window.fdc, t = window.currentVariant || e.variants[0], i = e.tags.find((e => e.includes("auto-discount")));
            i && (window.fdc.product.isHotDeal = !0, window.fdc.product.autoDiscountAmount = parseInt(i.split(":")[1]));
            const n = c.subSaveRadio && c.subSaveRadio.checked,
                a = t ? ((e, t) => e.autoDiscountAmount && e.isHotDeal ? 100 + e.autoDiscountAmount : e.autoDiscountAmount ? e.autoDiscountAmount : e.isHotDeal ? 100 : 0)(window.fdc.product) : 0,
                o = n ? .90 : 1;
            e.isHotDeal && t ? c.realPrice.innerHTML = `\n      <span class="sale">$${((t.price*o-a)/100).toFixed(2)}</span>\n      <span class="was_price">$${(t.price*o/100).toFixed(2)}</span>\n    ` : t && t.price !== t.compare_at_price && t.compare_at_price > 0 ? c.realPrice.innerHTML = `\n      <span class="sale">$${(t.price*o/100).toFixed(2)}</span>\n      <span class="was_price">$${(t.compare_at_price*o/100).toFixed(2)}</span>\n    ` : t && (c.realPrice.innerHTML = `$${(t.price*o/100).toFixed(2)}`), t && (c.priceStyle.innerHTML = `\n      [data-price-subsave], [data-price-onetime] { font-size: 0 !important; }\n      [data-price-subsave]::after, [data-price-onetime]::after { font-size: 20px; }\n      [data-price-subsave]::after { content: '$${((.90*t.price-a)/100).toFixed(2)}'; }\n      [data-price-onetime]::after { content: '$${((t.price-a)/100).toFixed(2)}'; }\n    `)
        };
    document.addEventListener("variantChange", p);
    document.addEventListener("DOMContentLoaded", (() => {
        e(t, i, n), t.mainPrice = document.querySelector(".current_price") || !1, document.addEventListener("productThumbsChanged", (e => {
            const i = Flickity.data(t.gallery).selectedIndex,
                n = t.thumbs[i];
            a(n), o(n)
        })), t.thumbs.forEach((e => {
            e.addEventListener("click", (() => {
                const i = Flickity.data(t.gallery),
                    r = parseInt(e.getAttribute(n.thumbs));
                i.select(r), a(e), o(e)
            }))
        })), (() => {
            if (e(c, d, s), window.fdc.product.tags.includes("use-bundle-pricing")) return void document.querySelector(".modal_price").setAttribute("style", "display: block !important");
            const t = document.createElement("div"),
                i = document.createElement("style");
            t.classList.add("real-price");
            const n = document.querySelector(".modal_price");
            n.parentNode.insertBefore(t, n), n.parentNode.appendChild(i), c.realPrice = t, c.priceStyle = i, p(), c.planButtons.forEach((e => {
                const t = e.getAttribute(s.planButtons);
                e.addEventListener("click", (() => (e => {
                    const t = document.querySelector(`[${d.subDD}]`) || !1;
                    t && (t.value = e)
                })(t)))
            })), document.addEventListener("click", (({
                target: e
            }) => {
                c.subRow && (e.hasAttribute(d.oneTime) || e.parentNode.hasAttribute(d.oneTime) ? (c.subRow.classList.add("hide-freq"), l("one-time"), p()) : (e.hasAttribute(d.subSave) || e.parentNode.hasAttribute(d.subSave)) && (c.subRow.classList.remove("hide-freq"), l("subscription"), p()))
            })), u()
        })()
    }))
})();